import { EngagementListener } from "../engagement/EngagementListener"
import { EngagementManager } from "../engagement/EngagementManager"
import { PageListener } from "../page/PageListener"
import { PageManager } from "../page/PageManager"
import { LifecycleChangeListener } from "./LifecycleChangeListener"
import { LifecycleManager } from "./LifecycleManager"

export interface LifecycleComposite {
  addPageListener(listener: PageListener): void
  addEngagementListener(listener: EngagementListener): void
  addLifecycleListener(listener: LifecycleChangeListener): void

  initialize(): void
}

export class LifecycleCompositeManager implements LifecycleComposite {
  constructor(
    readonly lifecycleManager: LifecycleManager,
    readonly pageManager: PageManager,
    readonly engagementManager: EngagementManager,
    browserName: string | null
  ) {
    this.lifecycleManager = lifecycleManager
    this.pageManager = pageManager
    this.engagementManager = engagementManager

    /**
     * Composite Lifecycle, Engagement and Page
     */
    this.install(typeof browserName === "string" ? browserName : null)
  }

  addPageListener(listener: PageListener): void {
    this.pageManager.addListener(listener)
  }

  addEngagementListener(listener: EngagementListener): void {
    this.engagementManager.addListener(listener)
  }

  addLifecycleListener(listener: LifecycleChangeListener): void {
    this.lifecycleManager.addListener(listener)
  }

  initialize(): void {
    this.lifecycleManager.initialize()
  }

  private install(browserName: string | null): void {
    this.pageManager.addListener(this.engagementManager)
    this.lifecycleManager.addListener(this.engagementManager)

    this.lifecycleManager.install(browserName)
  }
}
